import { authReducer } from "../Authentication/authSlice";
import { sendCodeReducer } from "../Code/sendCodeSlice";
import { codeVerifyReducer } from "../Code/codeVerifySlice";
import { servicesReducer } from "../Services/servicesSlice";
import { productsReducer } from "../Products/productsSlice";
import { addToCartReducer } from "../Cart/addToCartSlice";
import { getFromCartReducer } from "../Cart/getFromCartSlice";
import { getEmploeesReducer } from "../Employees/emploeesSlice";
import { orderReducer } from "../Order/orderSlice";
import { orderIdReducer } from "../Order/orderIdSlice";
import { categoriesReducer } from "../Categories/categoriesSlice";
import { orderDetailsReducer } from "../Order/orderDetailsSlice";
// import { reservationDetailsSlice } from "../Order/reservationDetailsSlice";
import { getEmployeeNameReducer } from "../Employees/employeeNameSlice";
import { sendNotificationReducer } from "../Code/sendNotificationSlice";
import { businessDataReducer } from "../Code/businessSlice";
import { sendPictureReducer } from "../Code/sendPictureSlice";
import { updateEcommIdReducer } from "../Order/updateEcommIdSlice";
import { reservationReducer } from "../Order/reservationSlice";

const reducers = {
  auth: authReducer,
  sendCode: sendCodeReducer,
  codeVerify: codeVerifyReducer,
  services: servicesReducer,
  products: productsReducer,
  addToCart: addToCartReducer,
  getFromCart: getFromCartReducer,
  getEmploees: getEmploeesReducer,
  getOrder: orderReducer,
  getOrderId: orderIdReducer,
  getCategories: categoriesReducer,
  orderDetails: orderDetailsReducer,
  employeeName: getEmployeeNameReducer,
  sendNotification: sendNotificationReducer,
  business: businessDataReducer,
  sendPicture: sendPictureReducer,
  updateEcommId: updateEcommIdReducer,
  reservation: reservationReducer,

  // reservationDetails: reservationDetailsSlice,
};

export default reducers;
